import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { from, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { fromApiEffectSwitchMap } from '../common/async/async.operators';
import {
  cancelGetBasicReservationInformationRequest,
  failGetBasicReservationInformation,
  setGetBasicReservationInformation,
  setGetBasicReservationInformationFromApi,
  updateGetBasicReservationInformation,
  updateGetBasicReservationInformationFromApi,
} from './get-basic-reservation-information.actions';

/**
 * Service to handle async GetBasicReservationInformation actions
 */
@Injectable()
export class GetBasicReservationInformationEffect {
  /**
   * Set the state with the reply content, dispatch failGetBasicReservationInformation if it catches a failure
   */
  public setFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setGetBasicReservationInformationFromApi),
      fromApiEffectSwitchMap(
        (reply, action) => setGetBasicReservationInformation({ ...reply, requestId: action.requestId }),
        (error, action) => of(failGetBasicReservationInformation({ error, requestId: action.requestId })),
        cancelGetBasicReservationInformationRequest
      )
    )
  );

  /**
   * Update the state with the reply content, dispatch failGetBasicReservationInformation if it catches a failure
   */
  public updateFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateGetBasicReservationInformationFromApi),
      mergeMap((payload) =>
        from(payload.call).pipe(
          map((reply) => updateGetBasicReservationInformation({ ...reply, requestId: payload.requestId })),
          catchError((err) => of(failGetBasicReservationInformation({ error: err, requestId: payload.requestId })))
        )
      )
    )
  );

  constructor(protected actions$: Actions) {}
}
